import { createContext } from 'react';

export const ApplicationContext = createContext();
